import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomerConstants from "../../common/CustomerConstants";
import AccountsFlowConstants from "../../common/AccountsFlowConstants";
import AccountsConstants from "../../common/AccountsConstants";
import { addInvoiceID } from "../../redux/feature/customer_app/preSalesSlice";
import { addcustomerID } from "../../redux/feature/customer_app/customerSlice";

/*
 * Open customer-app documents from the accounts-flow pages. The invoice and
 * loading-advice detail pages read the selected number from Redux (as their own
 * lists do); the order opens the order trail page with the number in the URL.
 * Invoices posted in the Accounts module carry its numbers (LA-…, SO-…), which open
 * the Accounts module lists instead.
 */
const ACCOUNTS_ADVICE = /^LA-/;
const ACCOUNTS_ORDER = /^SO-/;

export default function useDocNav() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return {
    openInvoice: (invoiceNr) => {
      if (!invoiceNr) return;
      dispatch(addInvoiceID(invoiceNr));
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_DETAILS);
    },
    openLoadingAdvice: (loadingAdviceNr) => {
      if (!loadingAdviceNr) return;
      if (ACCOUNTS_ADVICE.test(loadingAdviceNr)) {
        navigate(AccountsConstants.LOADING_ADVICES);
        return;
      }
      dispatch(addcustomerID(loadingAdviceNr));
      navigate(CustomerConstants.CUSTOMER_V2_LOADING_ADVICE_DETAIL);
    },
    openOrder: (orderNo) => {
      if (!orderNo) return;
      if (ACCOUNTS_ORDER.test(orderNo)) navigate(AccountsConstants.SALES_ORDERS);
      else navigate(`${AccountsFlowConstants.ORDER_TRAIL}?no=${encodeURIComponent(orderNo)}`);
    },
  };
}

const CHIP_ICON = { Invoice: "bi-receipt", Loading: "bi-truck", Order: "bi-cart", Purchase: "bi-bag" };

/* Labelled link to a document ("Invoice INV0025"); a plain chip when it can't be opened. */
export function DocChip({ label, no, onClick }) {
  const content = (
    <>
      <i className={`bi ${CHIP_ICON[label] || "bi-file-earmark"}`} aria-hidden="true" />
      <span className="flow-doc-chip-label">{label}</span>
      <span className="flow-doc-chip-no">{no}</span>
    </>
  );
  return onClick
    ? <button type="button" className="flow-doc-chip" title={`Open ${label.toLowerCase()} ${no}`} onClick={onClick}>{content}</button>
    : <span className="flow-doc-chip is-static">{content}</span>;
}

/* Clickable document number in the same style as the old lists. */
export function DocLink({ children, onClick, title }) {
  if (!children) return <span>--</span>;
  return (
    <button type="button" className="btnInfo" title={title} onClick={onClick}>
      {children}
    </button>
  );
}
